export default "__VITE_ASSET__F9JRtBb0__"